import React, { createContext, useContext, useState, useEffect } from 'react';
import { ethers } from 'ethers';

// Contract ABIs
const IERC20_ABI = [
    "function totalSupply() external view returns (uint256)",
    "function balanceOf(address account) external view returns (uint256)",
    "function transfer(address to, uint256 value) external returns (bool)",
    "function allowance(address owner, address spender) external view returns (uint256)",
    "function approve(address spender, uint256 value) external returns (bool)",
    "function transferFrom(address from, address to, uint256 value) external returns (bool)",
    "event Transfer(address indexed from, address indexed to, uint256 value)",
    "event Approval(address indexed owner, address indexed spender, uint256 value)"
];

const GrichInv_ABI = [
    // Variables
    "function liqHolder() external view returns (address)",
    "function approver() external view returns (address)",
    "function owner() external view returns (address)",
    "function usdtToken() external view returns (address)",
    "function cryptoToken() external view returns (address)",
    "function price() external view returns (uint256)",
    "function defaultRefer() external view returns (uint256)",
    "function rpFee() external view returns (uint256)",
    "function tokenPercent() external view returns (uint256)",
    "function directRefPercent() external view returns (uint256)",
    "function minDeposit() external view returns (uint256)",
    "function totalUsers() external view returns (uint256)",
    "function totalInvestmentsUSDT() external view returns (uint256)",
    "function royaltyPool() external view returns (uint256)",
    "function totalRoyaltyPool() external view returns (uint256)",
    "function dividendLastDist() external view returns (uint256)",
    
    // Mappings and structs
    "function usersInfo(uint256) external view returns (address acct, uint256 ref, uint256 upline, uint256 id, uint256 totalDepositUSDT, uint256 totalTokensClaimed, uint256 refIncomeUSDT, uint256 currentRoyaltyIncomeUSDT, uint256 royaltyIncomeUSDT, uint256 refCount, uint256 totalMatrixTeam)",
    "function royaltyUsersIndex(uint256) external view returns (uint256)",
    "function userTopUpWallet(uint256) external view returns (uint256)",
    "function id(address) external view returns (uint256)",
    "function activity(uint256) external view returns (uint256 id, uint256 usdtAmt, uint256 tokenAmt, uint256 mode, uint256 refId)",
    
    // Main functions
    "function buy(address _user, uint256 _ref, uint256 _amount, bool _useTopUpWallet) external payable",
    "function claimRoyaltyIncome() external",
    "function USDTtoCRYPTO(uint256 amt) external view returns (uint256)",
    
    // View functions
    "function getAllUsers() external view returns (tuple(address acct, uint256 ref, uint256 upline, uint256 id, uint256 totalDepositUSDT, uint256 totalTokensClaimed, uint256 refIncomeUSDT, uint256 currentRoyaltyIncomeUSDT, uint256 royaltyIncomeUSDT, uint256 refCount, uint256 totalMatrixTeam)[] memory)",
    "function getUserDetail(address _user) external view returns (tuple(address acct, uint256 ref, uint256 upline, uint256 id, uint256 totalDepositUSDT, uint256 totalTokensClaimed, uint256 refIncomeUSDT, uint256 currentRoyaltyIncomeUSDT, uint256 royaltyIncomeUSDT, uint256 refCount, uint256 totalMatrixTeam) memory)",
    "function getUserLevelRefs(uint256 user, uint256 _level) external view returns (uint256[] memory)",
    "function getUplineLevelRefs(uint256 user, uint256 _level) external view returns (uint256[] memory)",
    "function getUserLevelBusiness(uint256 user, uint256 _level) external view returns (uint256)",
    "function getUserLevelusersInfo(uint256 user, uint256 _level) external view returns (tuple(address acct, uint256 ref, uint256 upline, uint256 id, uint256 totalDepositUSDT, uint256 totalTokensClaimed, uint256 refIncomeUSDT, uint256 currentRoyaltyIncomeUSDT, uint256 royaltyIncomeUSDT, uint256 refCount, uint256 totalMatrixTeam)[] memory)",
    "function getUplineLevelusersInfo(uint256 user, uint256 _level) external view returns (tuple(address acct, uint256 ref, uint256 upline, uint256 id, uint256 totalDepositUSDT, uint256 totalTokensClaimed, uint256 refIncomeUSDT, uint256 currentRoyaltyIncomeUSDT, uint256 royaltyIncomeUSDT, uint256 refCount, uint256 totalMatrixTeam)[] memory)",
    "function getRecentActivities(uint256 _id, uint256 _page) external view returns (tuple(uint256 id, uint256 usdtAmt, uint256 tokenAmt, uint256 mode, uint256 refId)[] memory)",
    "function getUserActivitiesLength(uint256 _id) external view returns (uint256)",
    "function getUserTeamStats(uint256 _userId) external view returns (uint256 totalTeamBusiness, uint256 totalTeamCount)",
    "function getRoyaltyQualificationDetails(uint256 _userId) external view returns (bool isEligible, bool minInvestmentMet, bool minReferralsMet, bool qualifiedRefsMet, uint256 totalDirectBusiness, uint256 qualifiedRefsCount)",
    "function getMatrixStructure(uint256 _userId) external view returns (uint256[][] memory)",
    "function getLevelIncomeDetails(uint256 _userId, uint256 _level) external view returns (uint256 memberCount, uint256 levelBusiness, uint256 commissionRate, uint256 totalEarnings)",
    "function getActivityDetails(uint256 _userId, uint256 _activityId) external view returns (tuple(uint256 id, uint256 usdtAmt, uint256 tokenAmt, uint256 mode, uint256 refId) activityData, tuple(address acct, uint256 ref, uint256 upline, uint256 id, uint256 totalDepositUSDT, uint256 totalTokensClaimed, uint256 refIncomeUSDT, uint256 currentRoyaltyIncomeUSDT, uint256 royaltyIncomeUSDT, uint256 refCount, uint256 totalMatrixTeam) refUserInfo)",
    "function getUserActivitiesPaginated(uint256 _userId, uint256 _pageSize, uint256 _page) external view returns (tuple(uint256 id, uint256 usdtAmt, uint256 tokenAmt, uint256 mode, uint256 refId)[] activities, uint256 totalPages)",
    "function getMatrixDebugInfo(uint256 _userId) external view returns (uint256 userUpline, uint256 directCount, uint256[] memory directIds)",
    "function checkRoyaltyEligibility(uint256 _id) external view returns (bool)"
];

// Contract addresses - opBNB 
const USDT_ADDRESS = "0x9e5aac1ba1a2e6aed6b32689dfcf62a509ca96f3";
const CRYPTO_ADDRESS = "0x3edAdD42044d4fBC8b4a02414Ae4646608A3f309"; 
const CONTRACT_ADDRESS = "0x6aEfAA7798eF8662eB555E874930499a3A45DC7c";

// Create context
const Web3Context = createContext();

export const Web3Provider = ({ children }) => {
    const [isConnected, setIsConnected] = useState(false);
    const [account, setAccount] = useState(null);
    const [provider, setProvider] = useState(null);
    const [signer, setSigner] = useState(null);
    const [usdtContract, setUsdtContract] = useState(null);
    const [cryptoContract, setCryptoContract] = useState(null);
    const [grichInvContract, setGrichInvContract] = useState(null);
    const [userId, setUserId] = useState(0);
    const [userInfo, setUserInfo] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [notification, setNotification] = useState(null);

    // Initialize read-only provider 
    useEffect(() => {
        try {
            // Initialize with a read-only provider initially
            const readOnlyProvider = new ethers.providers.JsonRpcProvider('https://opbnb-mainnet-rpc.bnbchain.org/');
            setProvider(readOnlyProvider);
            
            // Initialize read-only contracts
            setUsdtContract(new ethers.Contract(USDT_ADDRESS, IERC20_ABI, readOnlyProvider));
            setCryptoContract(new ethers.Contract(CRYPTO_ADDRESS, IERC20_ABI, readOnlyProvider));
            setGrichInvContract(new ethers.Contract(CONTRACT_ADDRESS, GrichInv_ABI, readOnlyProvider));
        } catch (err) {
            console.error("Failed to initialize read-only provider:", err);
            setError("Failed to connect to the blockchain. Please refresh the page.");
        }
    }, []);

    // Handler for wallet connection
    const handleWalletConnect = async (walletAddress, web3Provider, walletType) => {
        try {
            setLoading(true);
            setError(null);
            
            // Create ethers provider from window.ethereum
            let ethersProvider;
            if (window.ethereum) {
                ethersProvider = new ethers.providers.Web3Provider(window.ethereum);
                // Request accounts access
                await window.ethereum.request({ method: 'eth_requestAccounts' });
            } else {
                throw new Error("No Ethereum provider found. Please install MetaMask.");
            }
            
            const signerInstance = ethersProvider.getSigner();
            const walletAddressFromSigner = await signerInstance.getAddress();
            
            setProvider(ethersProvider);
            setSigner(signerInstance);
            setAccount(walletAddressFromSigner);
            setIsConnected(true);
            
            // Initialize contract instances with signer
            const usdtWithSigner = new ethers.Contract(USDT_ADDRESS, IERC20_ABI, signerInstance);
            const cryptoWithSigner = new ethers.Contract(CRYPTO_ADDRESS, IERC20_ABI, signerInstance);
            const grichInvWithSigner = new ethers.Contract(CONTRACT_ADDRESS, GrichInv_ABI, signerInstance);
            
            setUsdtContract(usdtWithSigner);
            setCryptoContract(cryptoWithSigner);
            setGrichInvContract(grichInvWithSigner);
            
            // Load user data
            await loadUserData(walletAddressFromSigner, grichInvWithSigner);
            
            setLoading(false);
        } catch (err) {
            console.error("Wallet connection error:", err);
            setError("Failed to connect wallet. Please try again.");
            setLoading(false);
        }
    };

    // Handler for wallet disconnection
    const handleWalletDisconnect = () => {
        setIsConnected(false);
        setAccount(null);
        setSigner(null);
        setUserId(0);
        setUserInfo(null);
        
        // Reset to read-only provider
        const readOnlyProvider = new ethers.providers.JsonRpcProvider('https://opbnb-mainnet-rpc.bnbchain.org/');
        setProvider(readOnlyProvider);
        setUsdtContract(new ethers.Contract(USDT_ADDRESS, IERC20_ABI, readOnlyProvider));
        setCryptoContract(new ethers.Contract(CRYPTO_ADDRESS, IERC20_ABI, readOnlyProvider));
        setGrichInvContract(new ethers.Contract(CONTRACT_ADDRESS, GrichInv_ABI, readOnlyProvider));
    };

    // Load user data
    const loadUserData = async (walletAddress, contract) => {
        try {
            setLoading(true);
            
            // Get user ID
            const id = await contract.id(walletAddress);
            const userIdNumber = parseInt(id.toString());
            setUserId(userIdNumber);
            
            if (userIdNumber > 0) {
                // Get user details
                const userDetailResponse = await contract.getUserDetail(walletAddress);
                
                // Format the user info
                const formattedUserInfo = {
                    acct: userDetailResponse.acct,
                    ref: parseInt(userDetailResponse.ref.toString()),
                    upline: parseInt(userDetailResponse.upline.toString()),
                    id: parseInt(userDetailResponse.id.toString()),
                    totalDepositUSDT: ethers.utils.formatUnits(userDetailResponse.totalDepositUSDT, 18),
                    totalTokensClaimed: ethers.utils.formatUnits(userDetailResponse.totalTokensClaimed, 18),
                    refIncomeUSDT: ethers.utils.formatUnits(userDetailResponse.refIncomeUSDT, 18),
                    currentRoyaltyIncomeUSDT: ethers.utils.formatUnits(userDetailResponse.currentRoyaltyIncomeUSDT, 18),
                    royaltyIncomeUSDT: ethers.utils.formatUnits(userDetailResponse.royaltyIncomeUSDT, 18),
                    refCount: parseInt(userDetailResponse.refCount.toString()),
                    totalMatrixTeam: parseInt(userDetailResponse.totalMatrixTeam.toString())
                };
                
                // Get topup wallet balance
                try {
                    const topupWallet = await contract.userTopUpWallet(userIdNumber);
                    const topupWalletFormatted = ethers.utils.formatUnits(topupWallet, 18);
                    formattedUserInfo.topupWallet = topupWalletFormatted;
                } catch (err) {
                    console.warn("Error fetching topup wallet:", err);
                    formattedUserInfo.topupWallet = "0";
                }
                
                setUserInfo(formattedUserInfo);
            } else {
                setUserInfo(null);
            }
            
            setLoading(false);
        } catch (err) {
            console.error("Error loading user data:", err);
            setError("Failed to load user data");
            setLoading(false);
        }
    };

    // Make investment
const makeInvestment = async (amount, referrerId, useTopupWallet) => {
    try {
        setLoading(true);
        setError(null);
        
        // Convert amount to wei
        const amountWei = ethers.utils.parseUnits(amount.toString(), 18);
        
        // Minimum deposit check
        const minDeposit = await grichInvContract.minDeposit();
        if (amountWei.lt(minDeposit)) {
            const minDepositValue = ethers.utils.formatUnits(minDeposit, 18);
            throw new Error(`Minimum investment required is ${minDepositValue} USDT.`);
        }
        
        // Parse referrer ID
        let refId = 0;
        if (referrerId && referrerId !== "") {
            refId = parseInt(referrerId);
            if (isNaN(refId) || refId <= 0) {
                throw new Error("Please enter a valid referrer ID or leave it empty.");
            }
        }
        
        // If not using topup wallet, approve USDT transfer first
        if (!useTopupWallet) {
            const approveTx = await usdtContract.approve(CONTRACT_ADDRESS, amountWei);
            await approveTx.wait();
        }
        
        // Call buy function on the contract
        const buyTx = await grichInvContract.buy(
            account, 
            refId, 
            amountWei, 
            useTopupWallet
        );
        
        await buyTx.wait();
        
        // Refresh user data
        await loadUserData(account, grichInvContract);
        
        // Don't try to directly access showAiMessage here since we don't have it
        setLoading(false);
        
        // Set notification that will be displayed in the UI
        setNotification({
            title: "Investment Successful",
            message: `Your investment of ${amount} USDT has been processed successfully! You've received token cashback in your wallet.`
        });
        
        return true;
    } catch (err) {
        console.error("Investment failed:", err);
        setError(err.message || "Failed to process your investment. Please try again.");
        setLoading(false);
        return false;
    }
};


    // Claim royalty income
    const claimRoyaltyIncome = async () => {
        try {
            setLoading(true);
            setError(null);
            
            if (!userInfo || parseFloat(userInfo.currentRoyaltyIncomeUSDT) <= 0) {
                throw new Error("You don't have any royalty income to claim.");
            }
            
            const claimTx = await grichInvContract.claimRoyaltyIncome();
            await claimTx.wait();
            
            // Refresh user data
            await loadUserData(account, grichInvContract);
            
            setLoading(false);
            setNotification({
                title: "Claim Successful",
                message: "Your royalty income has been claimed successfully!"
            });
            
            return true;
        } catch (err) {
            console.error("Claim failed:", err);
            setError(err.message || "Failed to claim your royalty income. Please try again.");
            setLoading(false);
            return false;
        }
    };

    // Get referral link
    const getReferralLink = () => {
        if (userId > 0) {
            const baseUrl = window.location.origin;
            return `${baseUrl}?ref=${userId}`;
        }
        return null;
    };

    // Utility function to shorten Ethereum address
    const shortenAddress = (address) => {
        if (!address) return "";
        return address.substring(0, 6) + "..." + address.substring(address.length - 4);
    };

    // Show notification
    const showNotification = (title, message) => {
        setNotification({ title, message });
    };

    // Clear notification
    const clearNotification = () => {
        setNotification(null);
    };

    // Value object to be provided by the context
    const value = {
        isConnected,
        account,
        provider,
        signer,
        usdtContract,
        cryptoContract,
        grichInvContract,
        userId,
        userInfo,
        loading,
        error,
        notification,
        handleWalletConnect,
        handleWalletDisconnect,
        loadUserData,
        makeInvestment,
        claimRoyaltyIncome,
        getReferralLink,
        shortenAddress,
        showNotification,
        clearNotification,
        contractAddresses: {
            USDT_ADDRESS,
            CRYPTO_ADDRESS,
            CONTRACT_ADDRESS
        }
    };

    return (
        <Web3Context.Provider value={value}>
            {children}
        </Web3Context.Provider>
    );
};

// Custom hook to use the Web3 context
export const useWeb3 = () => {
    const context = useContext(Web3Context);
    if (context === undefined) {
        throw new Error("useWeb3 must be used within a Web3Provider");
    }
    return context;
};

export default Web3Context;